import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export function convertEvents(component, options) {
  var events = {};
  for (var _i = 0, _Object$entries = Object.entries((_component$events = component.events) !== null && _component$events !== void 0 ? _component$events : {}); _i < _Object$entries.length; _i++) {
    var _component$events;
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      event = _Object$entries$_i[0],
      handler = _Object$entries$_i[1];
    switch (component.name) {
      case "Table":
        switch (event) {
          case "select":
            {
              var action = convertEventHandlers(handler, options);
              if (action) {
                events["row.select.v2"] = action;
              }
              break;
            }
          case "sort":
            {
              var _action = convertEventHandlers(handler, options);
              if (_action) {
                events["sort.change"] = _action;
              }
              break;
            }
          case "paginate":
            {
              var _action2 = convertEventHandlers(handler, options);
              if (_action2) {
                events["page.change"] = _action2;
              }
              break;
            }
        }
        break;
      case "Button":
        if (event === "click") {
          var _action3 = convertEventHandlers(handler, options);
          if (_action3) {
            events.click = _action3;
          }
        }
        break;
      case "Search":
        if (event === "search") {
          var _action4 = convertEventHandlers(handler, options);
          if (_action4) {
            events.search = _action4;
          }
        }
        break;
      case "Select":
        if (event === "change") {
          var _action5 = convertEventHandlers(handler, options);
          if (_action5) {
            events["change.v2"] = _action5;
          }
        }
        break;
      default:
        {
          var _action6 = convertEventHandlers(handler, options);
          if (_action6) {
            events[event] = _action6;
          }
        }
    }
  }
  return Object.keys(events).length > 0 ? events : undefined;
}
export function convertEventHandlers(handler, options) {
  if (!handler) {
    return;
  }
  var list = (Array.isArray(handler) ? handler : [handler]).map(function (hdl) {
    return convertEventHandler(hdl, options);
  }).filter(Boolean);
  return list.length > 0 ? list : undefined;
}
function convertEventHandler(handler, options) {
  var _convertEventHandlers;
  switch (handler === null || handler === void 0 ? void 0 : handler.action) {
    case "update_variable":
      return {
        action: handler.payload.scope === "template" ? "state.set" : "context.set",
        args: [handler.payload.name, handler.payload.value]
      };
    case "refresh_data_source":
      return {
        action: handler.payload.scope === "template" ? "state.refresh" : "context.refresh",
        args: [handler.payload.name]
      };
    case "call_api":
      {
        var _handler$callback, _handler$callback2;
        var _handler$payload = handler.payload,
          api = _handler$payload.api,
          http = _handler$payload.http,
          tool = _handler$payload.tool,
          params = _handler$payload.params,
          isRawProvider = _handler$payload.isRawProvider;
        var success = (_handler$callback = handler.callback) !== null && _handler$callback !== void 0 && _handler$callback.success ? convertEventHandlers(handler.callback.success, options) : undefined;
        var error = (_handler$callback2 = handler.callback) !== null && _handler$callback2 !== void 0 && _handler$callback2.error ? convertEventHandlers(handler.callback.error, options) : undefined;
        return _objectSpread(_objectSpread({}, isRawProvider ? {
          useProvider: api,
          args: params
        } : http ? {
          useProvider: "basic.http-request",
          args: [api, params]
        } : tool ? {
          useProvider: "ai-portal.call-tool",
          args: [tool, params]
        } : {
          useProvider: "".concat(api).concat(api.includes(":") ? "" : ":*"),
          params: params
        }), {}, {
          callback: _objectSpread(_objectSpread({}, success && {
            success: success
          }), error && {
            error: error
          })
        });
      }
    case "call_ref":
      return _objectSpread(_objectSpread({}, handler.payload.scope === "template" ? {
        targetRef: handler.payload.ref
      } : {
        target: "".concat(options.rootId ? "[data-root-id=\"".concat(options.rootId, "\"] ") : "", "[data-ref=\"").concat(handler.payload.ref, "\"]")
      }), {}, {
        method: handler.payload.method,
        args: handler.payload.args
      });
    case "call_selector":
      return {
        target: handler.payload.selector,
        method: handler.payload.method,
        args: handler.payload.args
      };
    case "navigate":
      return {
        action: "history.".concat(handler.payload.method),
        args: handler.payload.args
      };
    case "show_message":
      return {
        action: "message.".concat(handler.payload.type),
        args: [handler.payload.content]
      };
    case "handle_http_error":
      return {
        action: "handleHttpError",
        args: [handler.payload]
      };
    case "dispatch_event":
      return {
        action: "tpl.dispatchEvent",
        args: [handler.payload.type, {
          detail: handler.payload.detail
        }]
      };
    case "conditional":
      return {
        "if": handler.payload.test,
        then: (_convertEventHandlers = convertEventHandlers(handler.payload.consequent, options)) !== null && _convertEventHandlers !== void 0 ? _convertEventHandlers : [],
        "else": convertEventHandlers(handler.payload.alternate, options)
      };
  }
}
//# sourceMappingURL=convertEvents.js.map